(ns teamoesterreich.admin-mode.detail-filter.text-search
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.util.helper :as h] ;;(h/event-value e)
            [teamoesterreich.util.log :as log]))




(defn wait-do [!waiting? !loaded? event-fn]
  (fn [e]
    (let [val (h/event-value e)]
      (js/console.log "wait or do" @!waiting?)
      (when @!waiting? (js/clearTimeout @!waiting?))
      (reset! !waiting?
              (js/setTimeout
                (fn []
                  (event-fn val)
                  (reset! !waiting? false)
                  (reset! !loaded? false))
                500)))))


(defn wait-do-check [!waiting? !loaded? event-fn]
  (fn [e val]
    (js/console.log "wait or do" val)
    (event-fn val)
    (reset! !waiting? false)
    (reset! !loaded? false)))

(defn search-block [!detail-search !searchAddFields !waiting? !loaded? searchAdd?]


  [mui/grid
   {:item true
    :xs 12
    :style {:marginBottom "7px"}
    }

   [mui/paper
    [mui/grid
     {:container true
      :direction "row"
      :alignItems "flex-start"
      :justify "flex-start"
      :spacing 1
      :style {:padding "5px"}
      }

     [mui/grid
      {:item true
       :md 6
       :xs 12
       }
      [mui/text-field
       {:defaultValue (str @!detail-search)
        :label       "Suche"
        :placeholder "suche..."
        :helper-text "Freitextsuche (TomId,Name,Tel,Email)"
        ;:class       (:text-field classes)
        :onChange   (wait-do !waiting? !loaded? (fn [val]
                                                  (reset! !detail-search val)))
        :fullWidth true
        :multiline false}]
      ]
     [mui/grid
      {:item true
       :md 6
       :xs 12
       }


      [mui/form-control
       {
        :component "fieldset"
        :fullWidth true
        }
       (when searchAdd?

       [mui/radio-group {:row true :class "filterRadio"}
        [mui/form-control-label {:label "TomId" :value "tomId" :placement "start"
                                 :control (r/as-element [mui/checkbox {:checked (get-in @!searchAddFields [:tomId])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !searchAddFields assoc :tomId %))}])}]
        [mui/form-control-label {:label "Name" :value "Name" :placement "start"
                                 :control (r/as-element [mui/checkbox {:checked (get-in @!searchAddFields [:name])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !searchAddFields assoc :name %))}])}]
        [mui/form-control-label {:label "Email" :value "email" :placement "start"
                                 :control (r/as-element [mui/checkbox {:checked (get-in @!searchAddFields [:email])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !searchAddFields assoc :email %))}])}]
        [mui/form-control-label {:label "Tel" :value "email" :placement "phone"
                                 :control (r/as-element [mui/checkbox {:checked (get-in @!searchAddFields [:phone])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !searchAddFields assoc :phone %))}])}]

        [mui/form-control-label {:label "Plz" :value "Plz" :placement "start"
                                 :control (r/as-element [mui/checkbox {:checked (get-in @!searchAddFields [:zip])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !searchAddFields assoc :zip %))}])}]

        [mui/form-control-label {:label "Ort" :value "Ort" :placement "start"
                                 :control (r/as-element [mui/checkbox {:checked (get-in @!searchAddFields [:city])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !searchAddFields assoc :city %))}])}]

        [mui/form-control-label {:label "Adresse" :value "Adresse" :placement "start"
                                 :control (r/as-element [mui/checkbox {:checked (get-in @!searchAddFields [:address])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !searchAddFields assoc :address %))}])}]

        [mui/form-control-label {:label "Dienststelle" :value "Ort" :placement "start"
                                 :control (r/as-element [mui/checkbox {:checked (get-in @!searchAddFields [:dienststelle])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !searchAddFields assoc :dienststelle %))}])}]

        [mui/form-control-label {:label "Geburtsdatum" :value "Geburtsdatum" :placement "start"
                                 :control (r/as-element [mui/checkbox {:checked (get-in @!searchAddFields [:birthday])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !searchAddFields assoc :birthday %))}])}]

        [mui/form-control-label {:label "Studium" :value "Studium" :placement "start"
                                 :control (r/as-element [mui/checkbox {:checked (get-in @!searchAddFields [:studium])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !searchAddFields assoc :studium %))}])}]
        [mui/form-control-label {:label "Beruf" :value "Beruf" :placement "start"
                                 :control (r/as-element [mui/checkbox {:checked (get-in @!searchAddFields [:job])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !searchAddFields assoc :job %))}])}]
        [mui/form-control-label {:label "Sachverständige(r)" :value "Sachverständige(r)" :placement "start"
                                 :control (r/as-element [mui/checkbox {:checked (get-in @!searchAddFields [:expert])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !searchAddFields assoc :expert %))}])}]
        [mui/form-control-label {:label "Ausbildungen" :value "Ausbildungen" :placement "start"
                                 :control (r/as-element [mui/checkbox {:checked (get-in @!searchAddFields [:ausbildungen])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !searchAddFields assoc :ausbildungen %))}])}]

        ])
       ]]]]


   ])